export enum SignatureTypeEnum {
  Confirmation = 'Confirmation',
  Signature = 'Signature'
}
